import Cookies from 'js-cookie';
import toast from "react-hot-toast";
import { axiosInstance } from '../lib/axios';

const getAllOrderFunction = async (pageNumber, pageSize, search, field, dateRange) => {
    try {

        const params = new URLSearchParams();
        params.append('field', field);
        params.append('search', search);
        params.append('pageSize', pageSize);
        params.append('pageNumber', pageNumber);
        params.append('dateRange', dateRange);

        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.get(`/order/allorders?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        console.log(res)
        // toast.success("Successfully fetched!");
        return res.data.data

    } catch (err) {
        console.log(err.res?.data?.message)
        toast.error(err.res?.data?.message || "Something went wrong!");
    }
}

const getOrderById = async (id) => {
    try {

        if (!id) {
            toast.error("id is not present");
        }
        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.get(`/order/${id}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        return res.data.data
    } catch (err) {
        console.log(err.res?.data?.message)
        toast.error(err.res?.data?.message || "Something went wrong!");
    }
}

const updateOrderById = async (id, orderStatus) => {
    try {

        if (!id) {
            toast.error("id is not present");
            return
        }
        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.put(`/order/${id}/update`,
            { orderStatus },
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        )
        toast.success("Successfully updated!");
        return res.data.data
    } catch (err) {
        console.log(err.res?.data?.message)
        toast.error(err.res?.data?.message || "Something went wrong!");
    }
}

const deleteOrder = async (id) => {
    try {

        if (!id) {
            toast.error("id is not present");
        }
        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.delete(`/order/${id}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
        })
        toast.success("Successfully deleted!");
        // return res.data.data

    } catch (err) {
        console.log(err.res?.data?.message)
        toast.error(err.res?.data?.message || "Something went wrong!");
    }
}

const dowloadOrderDetailFunction = async (id) => {
    try {
        if (!id) {
            toast.error("id is not present");
            return;
        }

        const accessToken = Cookies.get("accessToken");

        const res = await axiosInstance.post(
            `/order/dowload`,
            { id },
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                responseType: "arraybuffer",
            }
        );

        const blob = new Blob([res.data], { type: "application/pdf" });

        // Create a download link and simulate click
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "order-details.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Clean up
        window.URL.revokeObjectURL(link.href);
    } catch (err) {
        console.log(err.response?.data?.message);
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
};

const dowloadorderlist = async (pageNumber, pageSize, search, field) => {
    try {

        const params = new URLSearchParams();
        params.append('field', field);
        params.append('search', search);
        params.append('pageSize', pageSize);
        params.append('pageNumber', pageNumber);

        const accessToken = Cookies.get("accessToken");
        const res = await axiosInstance.get(`/order/dowloadordertable?${params.toString()}`, {
            headers: {
                Authorization: `Bearer ${accessToken}`,
            },
            responseType: "arraybuffer",
        })

        const blob = new Blob([res.data], { type: "application/pdf" });


        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);

        const now = new Date();
        const timeString = `${now.getHours()}_${now.getMinutes()}_${now.getSeconds()}`;
        link.download = `order-details_${timeString}.pdf`;


        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Clean up
        window.URL.revokeObjectURL(link.href);

    } catch (err) {
        console.log(err.response?.data?.message)
        toast.error(err.response?.data?.message || "Something went wrong!");
    }
}


export {
    deleteOrder,
    getOrderById,
    updateOrderById,
    dowloadorderlist,
    getAllOrderFunction,
    dowloadOrderDetailFunction
}
